module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9677.991f0582.jpg";